import _defineProperty from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { generateMetaTagsFromEntity } from '../../../helpers/metatag';
import { nodeGet } from '../../../redux/actions/Entity/Node';
import EntityMapperContext from '../../../Context/EntityMapperContext';
import ContextualActionsButtons from '../../../Components/ContextualActions/Buttons';

var Node = /*#__PURE__*/function (_Component) {
  _inherits(Node, _Component);

  function Node() {
    _classCallCheck(this, Node);

    return _possibleConstructorReturn(this, _getPrototypeOf(Node).apply(this, arguments));
  }

  _createClass(Node, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          entity = _this$props.entity,
          id = _this$props.id,
          dispatch = _this$props.dispatch,
          viewMode = _this$props.viewMode,
          currentLanguage = _this$props.currentLanguage;

      if (id && (!entity || entity.getIn(['langcode', 0, 'value']) !== currentLanguage)) {
        dispatch(nodeGet(id, viewMode));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          id = _this$props2.id,
          dispatch = _this$props2.dispatch,
          viewMode = _this$props2.viewMode,
          currentLanguage = _this$props2.currentLanguage;

      if (id && (id !== prevProps.id || currentLanguage !== prevProps.currentLanguage)) {
        dispatch(nodeGet(id, viewMode));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          entity = _this$props3.entity,
          viewMode = _this$props3.viewMode,
          className = _this$props3.className,
          isRootNode = _this$props3.isRootNode,
          currentLanguage = _this$props3.currentLanguage,
          props = _objectWithoutProperties(_this$props3, ["id", "entity", "viewMode", "className", "isRootNode", "currentLanguage"]);

      var classes = classNames(className, 'Node');

      if (!entity) {
        return null;
      }

      var nodeType = entity.getIn(['type', 0, 'target_id']);
      return /*#__PURE__*/React.createElement(EntityMapperContext.Consumer, null, function (entityTypesMapper) {
        var nodeMappers = entityTypesMapper.node;
        var NodeComponent = nodeMappers[nodeType];

        if (NodeComponent) {
          return /*#__PURE__*/React.createElement(ContextualActionsButtons, {
            entityType: "node",
            entityId: id
          }, isRootNode && /*#__PURE__*/React.createElement(Helmet, {
            htmlAttributes: {
              lang: currentLanguage
            }
          }, generateMetaTagsFromEntity(entity)), /*#__PURE__*/React.createElement(NodeComponent, _extends({}, props, {
            className: classes,
            entity: entity,
            viewMode: viewMode,
            id: id
          })));
        }

        return /*#__PURE__*/React.createElement("div", null, nodeType);
      });
    }
  }]);

  return Node;
}(Component);

function mapStateToProps(state, ownProps) {
  return _objectSpread({}, ownProps, {
    id: ownProps.id,
    isRootNode: ownProps.root,
    viewMode: ownProps.viewMode,
    entity: ownProps.entity || state.getIn(['node', ownProps.id]),
    currentLanguage: state.getIn(['ui', 'language'])
  });
}

export default connect(mapStateToProps)(Node);